(function () {

  /* =========================================================
     VALIDATION
  ========================================================= */

  function validateDeliveryCode(value, mode) {

    const code = value.trim();


    if (!code) {
      return {
        valid: false,
        message: 'Please enter your delivery ZIP or postal code.'
      };
    }


    /* US ZIP */

    if (mode === 'us_zip') {

      const usZipPattern =
        /^\d{5}(?:-\d{4})?$/;

      if (!usZipPattern.test(code)) {

        return {
          valid: false,
          message: 'Please enter a valid 5-digit ZIP code.'
        };

      }

    }


    /* CANADA */

    if (mode === 'ca_postal') {

      const canadaPattern =
        /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

      if (!canadaPattern.test(code)) {

        return {
          valid: false,
          message: 'Please enter a valid Canadian postal code.'
        };

      }

    }


    return {
      valid: true,
      value: code
    };

  }



  /* =========================================================
     NORMALIZE DELIVERY CODE
  ========================================================= */

  function normalizeDeliveryCode(value, mode) {

    let code =
      value.trim();


    if (mode === 'ca_postal') {

      code =
        code
          .replace(/\s+/g, '')
          .toUpperCase();


      if (code.length === 6) {

        code =
          code.slice(0, 3) +
          ' ' +
          code.slice(3);

      }

    }


    return code;

  }



  /* =========================================================
     BUILD DESTINATION URL
  ========================================================= */

  function buildDestinationUrl(
    destination,
    deliveryCode,
    mode,
    passDeliveryCode
  ) {

    const url =
      new URL(
        destination,
        window.location.origin
      );


    if (!passDeliveryCode) {
      return url.toString();
    }


    let queryKey =
      'delivery_code';


    if (mode === 'us_zip') {

      queryKey =
        'delivery_zip';

    } else if (
      mode === 'ca_postal'
    ) {

      queryKey =
        'delivery_postal';

    }


    url.searchParams.set(
      queryKey,
      deliveryCode
    );


    return url.toString();

  }



  /* =========================================================
     INITIALIZE SINGLE GIFT FINDER
  ========================================================= */

  function initGiftFinder(section) {

    if (!section) {
      return;
    }


    if (
      section.dataset
        .giftFinderInitialized ===
      'true'
    ) {
      return;
    }


    const form =
      section.querySelector(
        '[data-gift-finder-form]'
      );


    const codeInput =
      section.querySelector(
        '[data-gift-finder-code]'
      );


    const occasionSelect =
      section.querySelector(
        '[data-gift-finder-occasion]'
      );


    const errorElement =
      section.querySelector(
        '[data-gift-finder-error]'
      );


    if (
      !form ||
      !codeInput ||
      !occasionSelect
    ) {
      return;
    }


    section.dataset
      .giftFinderInitialized =
      'true';



    /* =======================================================
       CLEAR ERROR WHEN USER TYPES
    ======================================================= */

    codeInput.addEventListener(
      'input',
      function () {

        codeInput.removeAttribute(
          'aria-invalid'
        );


        if (errorElement) {

          errorElement.textContent =
            '';

        }

      }
    );



    /* =======================================================
       FORM SUBMIT
    ======================================================= */

    form.addEventListener(
      'submit',
      function (event) {

        /*
         * CRITICAL:
         * Stops browser from adding form values
         * to the current/home page URL.
         */
        event.preventDefault();


        const mode =
          section.dataset.codeMode ||
          'us_zip';


        const validation =
          validateDeliveryCode(
            codeInput.value,
            mode
          );


        /* INVALID ZIP */

        if (!validation.valid) {

          codeInput.setAttribute(
            'aria-invalid',
            'true'
          );


          if (errorElement) {

            errorElement.textContent =
              validation.message;

          }


          codeInput.focus();

          return;
        }



        /* Normalize */

        const deliveryCode =
          normalizeDeliveryCode(
            validation.value,
            mode
          );



        /* Current occasion */

        const selectedOption =
          occasionSelect.options[
            occasionSelect.selectedIndex
          ];


        const occasionUrl =
          selectedOption
            ? selectedOption.dataset.url
            : '';


        const fallbackUrl =
          section.dataset.fallbackUrl ||
          '';


        const destination =
          occasionUrl ||
          fallbackUrl;



        /* NO DESTINATION CONFIGURED */

        if (!destination) {

          if (errorElement) {

            errorElement.textContent =
              'Please configure a destination collection for this occasion.';

          }

          return;
        }



        /* ===================================================
           SAVE ZIP IN SESSION

           Useful later if we want to show:

           "Showing gifts for 10001"

           on the collection page.
        =================================================== */

        try {

          sessionStorage.setItem(
            'skyline_delivery_code',
            deliveryCode
          );


          sessionStorage.setItem(
            'skyline_delivery_mode',
            mode
          );


          sessionStorage.setItem(
            'skyline_gift_occasion',
            selectedOption
              ? selectedOption.value
              : ''
          );

        } catch (error) {

          /*
           * sessionStorage being unavailable
           * should never block the redirect.
           */

        }



        /* ===================================================
           BUILD SHOPIFY COLLECTION URL
        =================================================== */

        const passDeliveryCode =
          section.dataset
            .passDeliveryCode ===
          'true';


        const redirectUrl =
          buildDestinationUrl(
            destination,
            deliveryCode,
            mode,
            passDeliveryCode
          );



        /* ===================================================
           REDIRECT
        =================================================== */

        window.location.assign(
          redirectUrl
        );

      }
    );

  }



  /* =========================================================
     INITIALIZE ALL
  ========================================================= */

  function initAllGiftFinders(root) {

    root =
      root || document;


    if (
      root.matches &&
      root.matches(
        '[data-gift-finder]'
      )
    ) {

      initGiftFinder(root);

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '[data-gift-finder]'
        )
        .forEach(
          function (section) {

            initGiftFinder(
              section
            );

          }
        );

    }

  }



  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  function boot() {

    initAllGiftFinders(
      document
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );

  } else {

    boot();

  }
if (mode === 'ca_postal') {

  const canadaPattern =
    /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  if (!canadaPattern.test(code)) {

    return {
      valid: false,
      message: 'Please enter a valid Canadian postal code.'
    };

  }

}


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAllGiftFinders(
        event.target
      );

    }
  );

})();